import React from "react"
import { observer } from "mobx-react-lite"
import { Select, Option, Typography, Button } from "@material-tailwind/react"
import { runInAction } from "mobx"

import { userAccountController } from "../../../Common/Controllers/UserAccountController"
import { alertFrequencyOptions } from "../../../Common/DTOs/StockistDTO"
import { alertController } from "../../../Common/Controllers/AlertController"

export const SettingsSubpage = observer(() => {
  React.useEffect(() => {
    const initSettings = async () => {
      if (userAccountController.isUserAccountDataLoading) return;
      if (!userAccountController.isLoggedIn) return;

      await userAccountController.getStockist();
      userAccountController.setWorkingStockist();

      runInAction(() => {
        userAccountController.startEditingSettings();
      });
    };

    void initSettings();

    return () => {
      runInAction(() => userAccountController.settingsDraft = null);
      userAccountController.resetWorkingStockist();
    };
  }, [
    userAccountController.isUserAccountDataLoading,
    userAccountController.isLoggedIn
  ]);

  const onSaveSettings = async () => {
    userAccountController.applySettingsChanges();

    try {
      await userAccountController.saveStockistEdits();
      alertController.displayAlert("Changes saved successfully", null, "success", 4000);
    }
    catch {
      alertController.displayAlert("Something went wrong", "Please try again", "error", 4000);
    }
  };

  return (
    userAccountController.settingsDraft && userAccountController.workingStockist &&
    <div className="flex flex-grow flex-col gap-4 justify-start items-center animate-fadeIn">
      <Typography variant={"h3"} color={"white"}>Settings</Typography>
      <div className="w-[300px] md:w-[400px] h-[50px]">
        <Select
          size="lg"
          className="text-white"
          labelProps={{ className: "text-white" }}
          label="Cover Alerts Frequency"
          value={userAccountController.settingsDraft?.coverAlertsFrequency.toString()}
          onChange={(value) => {
            if (value) {
              runInAction(() => userAccountController.settingsDraft!.coverAlertsFrequency = Number(value));
            }
          }}
        >
          {alertFrequencyOptions.map((opt) => (
            <Option
              key={opt.value}
              value={opt.value.toString()}
            >
              {opt.label}
            </Option>
          ))}
        </Select>
      </div>
      <div className="flex gap-4 pt-4">
        <Button
          size={"lg"}
          className={"w-[300px] md:w-[400px] h-[60px] bg-purple"}
          disabled={!userAccountController.isSettingsDirty}
          onClick={onSaveSettings}
        >
          <Typography variant={"h5"}>Save</Typography>
        </Button>
      </div>
    </div>
  )
})